import { useState } from 'react';
import lodash from 'lodash';
import {
  Edit,
  SaveButton,
  Toolbar,
  useCreate,
  useGetList,
  useNotify,
} from 'react-admin';
import SaveIcon from '@mui/icons-material/Save';
import { WizardForm } from '../../components';
import { ContractFuel, ContractProduct } from '../../models';
import { getChainId, getUserId } from '../../utils/utils';
import { BasicInfoStep, RulesStep, DealsStep, SummaryStep } from './Steps';

const ContractEdit = (props) => {
  const [create] = useCreate();
  const notify = useNotify();

  const { data: fuels } = useGetList('fuels', { sort: { field: 'name', order: 'ASC' }, pagination: null });

  const [chatData, setChatData] = useState(null);

  const createChatMessage = ({ contractId, subject, body, chatFiles, participantIds }) => new Promise((resolve, reject) => {
    if (subject || body || chatFiles) {
      notify('Enviando sua mensagem');

      const data = {
        subject: subject || '(Sem assunto)',
        chatMessage: {
          body,
          files: chatFiles,
        },
        employeeId: getUserId(),
        chainId: getChainId(),
        origin: 'contract',
        contractId,
      }

      if (participantIds) {
        data.participantIds = participantIds;
      }

      create('chats', { data }, {
        onSettled: (_data, error) => {
          if (error.status) {
            notify(error.message || 'Não foi possível encaminhar a mensagem, mas pode ser feito uma nova tentativa na tela de notas fiscais', { type: 'warning' });
            reject(error);
            return;
          }

          notify('Mensagem enviada');
          resolve(_data);
        }
      });
    } else {
      resolve(null);
    }
  });

  return (
    <Edit
      {...props}
      title='Editar Contrato'
      transform={({ subject, body, chatFiles, participantIds, ...data }) => {
        setChatData({ subject, body, chatFiles, participantIds });

        if (data.filePath) {
          data.files = data.filePath.filter(file => file.rawFile);
          data.filePath = data.filePath.filter(file => !file.rawFile);
        }

        if (data.contractProducts?.length) {
          data.contractProducts = data.contractProducts.map(contractProduct => lodash.omitBy(new ContractProduct(contractProduct), lodash.isNil));
        }

        if (data.contractFuels?.length) {
          data.contractFuels = data.contractFuels.map(contractFuel => new ContractFuel(contractFuel));
        }

        delete data.contractStations;
        return data;
      }}
      mutationOptions={{
        onSettled: async (data, error) => {
          if (error) {
            notify(error.message || 'Não foi possível editar o contrato.', { type: 'warning' });
            return;
          }
          await createChatMessage({ ...chatData, contractId: data.id });
        },
      }}
      redirect="list"
    >
      <WizardForm
        formSteps={[
          {
            label: 'Informações Básicas',
            component: <BasicInfoStep isEdit />,
          },
          {
            label: 'Regras e Faturamento',
            component: <RulesStep />,
          },
          {
            label: 'Acordos',
            component: <DealsStep fuels={fuels} isEdit />,
          },
          {
            label: 'Resumo',
            component: <SummaryStep isEdit />,
            customToolbar: (
              <Toolbar>
                <SaveButton
                  label="Salvar Alterações"
                  icon={<SaveIcon />}
                />
              </Toolbar>
            ),
          },
        ]}
      />
    </Edit>
  );
};

export default ContractEdit;
